var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPenaltyShootoutGoal(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("polyline", {
    points: "10.55 7.39 9.78 7.39 9.78 12.88 9.78 13.41 9.78 19.13 9.78 19.65 9.78 24.53 9.64 24.53 8.93 24.53 6.88 24.53 6.88 22.56 6.88 22.48 6.88 16.31 6.88 16.22 6.88 10.06 6.88 9.97 6.93 10.02",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 16.81,
    y1: 7.39,
    x2: 15.79,
    y2: 7.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.06,
    y1: 7.39,
    x2: 22.05,
    y2: 7.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 33.32,
    y1: 7.39,
    x2: 32.31,
    y2: 7.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 39.57,
    y1: 7.39,
    x2: 38.55,
    y2: 7.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.19,
    y1: 11.01,
    x2: 43.19,
    y2: 9.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.19,
    y1: 17.27,
    x2: 43.19,
    y2: 15.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.19,
    y1: 23.52,
    x2: 43.19,
    y2: 21.52,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.93,
    y1: 16.27,
    x2: 6.88,
    y2: 16.22,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.93,
    y1: 22.52,
    x2: 6.88,
    y2: 22.48,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.93,
    y1: 10.01,
    x2: 6.88,
    y2: 10.06,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.93,
    y1: 16.27,
    x2: 6.88,
    y2: 16.31,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.88,
    y1: 24.46,
    x2: 6.81,
    y2: 24.53,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.93,
    y1: 22.52,
    x2: 6.88,
    y2: 22.56,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.19,
    y1: 15.27,
    x2: 43.19,
    y2: 11.01,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polyline", {
    points: "43.19 23.52 43.19 24.53 40.29 24.53 40.29 24.42 40.29 20.62 40.29 18.16 40.29 14.38 40.29 11.91 40.29 8.12 40.29 7.39 39.57 7.39",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.19,9V5.94a1.45,1.45,0,0,0-1.45-1.45H8.33A1.45,1.45,0,0,0,6.88,5.94v4l0,0",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 15.79,
    y1: 7.39,
    x2: 10.55,
    y2: 7.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.05,
    y1: 7.39,
    x2: 16.81,
    y2: 7.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 32.31,
    y1: 7.39,
    x2: 23.06,
    y2: 7.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 38.55,
    y1: 7.39,
    x2: 33.32,
    y2: 7.39,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 43.19,
    y1: 21.52,
    x2: 43.19,
    y2: 17.27,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 40.29,
    y1: 24.42,
    x2: 40.18,
    y2: 24.53,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 40.62,
    r: 4.63,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.23,
    y1: 45.51,
    x2: 28.77,
    y2: 45.51,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.29,
    y1: 24.53,
    x2: 48.71,
    y2: 24.53,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1.29,
    y1: 33.29,
    x2: 48.71,
    y2: 33.29,
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.62 26.86 34.54 25.46 30.23 35 26.71 33.41 31.02 23.87 27.93 22.48 32.03 19.87 36.12 17.27 36.87 22.06 37.62 26.86",
    style: {
      fill: "#fff",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.8,
    cy: 12.61,
    r: 0.72,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.6713734449050008px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25,14.72l3.93,1.4",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 20.68,
    y1: 14.19,
    x2: 24.61,
    y2: 15.34,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.04,
    y1: 17.49,
    x2: 28.13,
    y2: 20.75,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 21.74,
    y1: 19.29,
    x2: 26.01,
    y2: 23.56,
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.67,
    y: 14.88,
    width: 2.24,
    height: 3.85,
    transform: "translate(-5.79 19.62) rotate(-45)",
    style: {
      stroke: "#000",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPenaltyShootoutGoal);
export default __webpack_public_path__ + "static/media/PENALTY_SHOOTOUT_GOAL.bc63e8fd884729bd3daf72f6f7868eb1.svg";
export { ForwardRef as ReactComponent };